import { CommonDT, DateFilter, PageParams, ResultType, Sorter } from '../../CommonDT';
import { _delete, _get, _post, _put, _req } from '../../request';

export type VersionDataType = CommonDT & {
  versionKey: number;
  versionName: string;
  versionDesc: string;
  versionDetail: string;
  versionType: number; // 1 - Alpha内测, 2 - Release发行, 3 - Fixed修复
  upgradeType: number; // 1 - 全量更新, 2 - 热更新
  fileName: string;
  fileMd5: string;
  filePath: string;
  fileLink: string;
  pushTime: string;
  pullTimes: number;
  loadTimes: number;
  isActived: number; // 0 - 未启用, 1 - 已启用
};

export type VersionBatchDataType = {
  versions: VersionDataType[];
};

export type VersionPageDataType = {
  pageParams: PageParams;
  filter?: VersionDataType;
  dateFilter?: DateFilter;
  sorter?: Sorter;
};

export type VersionPushVO = {
  versionName: string;
  versionDesc: string;
  versionType: number; // 1 - Alpha内测, 2 - Release发行, 3 - Fixed修复
  upgradeType: number; // 1 - 全量更新, 2 - 热更新
  filedata?: File; // 用 File 类型表示二进制文件 (可选字段)
};

const get = async (id: string): Promise<ResultType> => {
  return await _get('/sys/version/', id);
};

const list = async (data?: VersionDataType): Promise<ResultType> => {
  return await _post('/sys/version/list', data);
};

const page = async (data?: VersionPageDataType): Promise<ResultType> => {
  return await _post('/sys/version/page', data);
};

const batchSave = async (data: VersionBatchDataType): Promise<ResultType> => {
  return await _post('/sys/version/batchSave', data);
};

const batchUpdate = async (data: VersionBatchDataType): Promise<ResultType> => {
  return await _put('/sys/version/batchUpdate', data);
};

const alterStatus = async (versionId: string, status: number): Promise<ResultType> => {
  return await _req('/sys/version/alterStatus', 'PUT', { versionId, status });
};

const batchRemove = async (ids: string[]): Promise<ResultType> => {
  return await _delete('/sys/version/batchRemove', ids);
};

const pull = async (nowVersionKey: number, upgradeType: number): Promise<ResultType> => {
  return await _req('/sys/version/pull', 'GET', { nowVersionKey, upgradeType }, {});
};

const overLoad = async (versionKey: number): Promise<ResultType> => {
  return await _req('/sys/version/overLoad', 'GET', { versionKey }, {});
};

const history = async (): Promise<ResultType> => {
  return await _req('/sys/version/history', 'GET', {}, {});
};

const alterActived = async (versionKey: number, actived: boolean): Promise<ResultType> => {
  return await _req('/sys/version/alterActived', 'GET', { versionKey, actived });
};

// 这里要使用表单
// const push = async (versionId: string, status: number): Promise<ResultType> => {
//   return await _req('/sys/version/push', 'POST', { versionId, status });
// };

const VersionApi = {
  get,
  list,
  page,
  batchSave,
  batchUpdate,
  alterStatus,
  batchRemove,
  pull,
  overLoad,
  history,
  alterActived,
  // push,
};

export default VersionApi;
